// Promise.all that takes hashmaps (since native Promise.all does not support objects)
const allMap = async <T>(promises: {
  [key: string]: Promise<T>;
}): Promise<{ [key: string]: T }> => {
  const keys = Object.keys(promises);
  const promiseArray = keys.map((key: string) => promises[key]);

  const results = await Promise.all(promiseArray);
  const hashmapResults = {};

  keys.forEach((key, index) => {
    hashmapResults[key] = results[index];
  });

  return hashmapResults;
};

export const PromiseHelpers = {
  allMap,
};
